import { render } from "./tasksEdit.vue?vue&type=template&id=2aca055e&scoped=true"
import script from "./tasksEdit.vue?vue&type=script&lang=js"
export * from "./tasksEdit.vue?vue&type=script&lang=js"

import "./tasksEdit.vue?vue&type=style&index=0&id=2aca055e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aca055e"]])

export default __exports__